/* Owns the loading placeholder. Shaped like the final layout, never a
   spinner-only screen, so resolving a query causes no layout shift. The shimmer
   is one 1.4 s sweep and is disabled under prefers-reduced-motion (index.css). */

import type { ReactNode } from 'react'

import { cn } from './cn.js'

export interface SkeletonProps {
  width?: string
  height?: string
  rounded?: 'sm' | 'md' | 'lg' | 'full'
  count?: number
  className?: string
  'data-testid'?: string
}

const ROUNDED = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
} as const

export function Skeleton({
  width = '100%',
  height = '1rem',
  rounded = 'md',
  count = 1,
  className,
  'data-testid': testId,
}: SkeletonProps): ReactNode {
  return (
    <>
      {Array.from({ length: count }, (_unused, index) => (
        <span
          key={index}
          aria-hidden
          data-testid={testId}
          /* Only the dimensions the caller actually passed.
         An inline style always beats a utility class, so emitting
         `height: '1rem'` by default silently killed every `className="h-40"`
         — which is exactly how the plan page's loading block rendered as a
         16 px sliver. */
      style={{
        ...(width !== undefined ? { width } : {}),
        ...(height !== undefined ? { height } : {}),
      }}
          className={cn('sac-shimmer block', ROUNDED[rounded], className)}
        />
      ))}
    </>
  )
}
